import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { selectRenderGame } from 'src/slices/game.slice';
import { selectIsMobileOrTablet } from 'src/slices/app.slice';
import { selectIsMobileTestingMode } from 'src/slices/inspector.slice';

import Qr from 'src/components/ui/Qr';
import GameEmbed from 'src/components/ui/GameEmbed';
import GameUploader from 'src/components/ui/GameUploader';

const GameModuleWrapper = styled.div`
    position: relative;
    display: flex;
    flex: 1 1 auto;
    justify-content: center;
    align-items: center;
    width: 100%;
    min-height: 320px;
    padding: 16px;
    background-color: var(--surface);
    border-radius: 8px 8px 0 0;

    ${({ $isMobileOrTablet }) => $isMobileOrTablet && `
        height: 100%;
        border-radius: 0;
        padding: 0;
    `}
`;

export default function GameModule() {
    const gameModuleRef = useRef();

    const [dimensions, setDimensions] = useState({ height: 0, width: 0 });

    const isMobileTestingMode = useSelector(selectIsMobileTestingMode);
    const isMobileOrTablet = useSelector(selectIsMobileOrTablet);
    const shouldRenderGame = useSelector(selectRenderGame);

    useEffect(() => {
        if (gameModuleRef.current) {
            setDimensions({
                height: gameModuleRef.current.offsetHeight,
                width: gameModuleRef.current.offsetWidth
            })
        }
    }, [shouldRenderGame]);
    return (
        <GameModuleWrapper $isMobileOrTablet={isMobileOrTablet} ref={gameModuleRef}>
            {!shouldRenderGame && <GameUploader />}
            {shouldRenderGame && !isMobileTestingMode && (
                <GameEmbed gameModule={dimensions} />
            )}

            {shouldRenderGame && isMobileTestingMode && <Qr />}
        </GameModuleWrapper>
    );
}
